export enum TrainMode {
  ALL = 'ALL',
  BY_WORD = 'BY_WORD',
  TR_MODE_LEVEL_0 = 'TR_MODE_LEVEL_0',
  TR_MODE_LEVEL_1 = 'TR_MODE_LEVEL_1',
  TR_MODE_LEVEL_2 = 'TR_MODE_LEVEL_2',
  TR_MODE_LEVEL_3 = 'TR_MODE_LEVEL_3',
  TR_MODE_LEVEL_4 = 'TR_MODE_LEVEL_4',
  TR_MODE_LEVEL_5 = 'TR_MODE_LEVEL_5',
  TR_MODE_LEVEL_6 = 'TR_MODE_LEVEL_6',
  TR_MODE_LEVEL_7 = 'TR_MODE_LEVEL_7',
}
